export function electionDaysLeft(now = new Date()) {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Sao_Paulo', year: 'numeric', month: 'numeric', day: 'numeric',
  }).formatToParts(now);
  const part = (type: string) => Number(parts.find((item) => item.type === type)!.value);
  const today = Date.UTC(part('year'), part('month') - 1, part('day'));
  return Math.max(0, Math.round((Date.UTC(2026, 9, 4) - today) / 86400000));
}
